import React from "react";
import { PageRoute } from "@quest-finance/quest-fe-shared/dist/common/types/PageRoute";

const Resources = React.lazy(() => import("../pages/Resources"));
const Training = React.lazy(() => import("../pages/Training"));

const routes: PageRoute[] = [
  {
    path: "/resources",
    exact: true,
    component: Resources,
  },
  {
    path: "/training",
    exact: true,
    component: Training,
  },
];

export default routes;
